require('ffss/common');

const DateRangePicker = require('ffss/ui/DateRangePicker');
const Menu = require('ffss/component/Menu');
const DocMenu = require('ffss/component/doc/Menu');
const Carousel = require('ffss/component/Carousel');
const BtnExportExecutor = require('ffss/component/BtnExportExecutor');

class Application {
    defaultOptions() {
        return {
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.googleMapAvailable = false;
        this.events = {};

        this.initialize();
    }

    get(key){
        return this.settings[key] ?? null;
    }

    initialize() {
        //this.notify("FFSS Application loaded","info");

        // const modal = new Modal(document.getElementById('myModal'))

        $('.select2').select2();

        $('.input-daterangepicker').each(function(){
            let $input = $(this);
            new DateRangePicker({
                '$input': $input,
            })
        });

        if($(".block-three-images .col").length > 1 && $(window).width() < 768){
            $('.block-three-images .flexslider').flexslider({
                animation: "slide",
                controlNav: false,
                directionNav: false,
                itemWidth: 250,
                itemMargin: 20
            });
        }

        $(".popup_video").click(function(){
           let href = $(this).attr('href');
           $("#videoPopup iframe").attr('src', href);
        });

        $("#videoPopup .close").click(function(){
            $("#videoPopup iframe").attr('src', '');
        });


        let $homeHeaderWrapper = $('.home-header__wrapper');

        if($homeHeaderWrapper.length > 0){
            this.carousel = new Carousel({
                '$container': $homeHeaderWrapper,
                'sliderSelector': '.home-header__big--items',
                'linkSelector': '.home-header__thumb--item',
            })
        }

        if($(".block-three-columns-icon-text__container").length > 0){
            $(".block-three-columns-icon-text__container .item").each(function(){
                let $linkItem = $(this).find(".item__content a").clone();
                $linkItem.text('');
                $(this).append($linkItem);
            })
        }

        $(".scroll-down").click(function(e){
            e.preventDefault();

            let top_Actua = $(".block-news-short-list").offset().top;

            $("html, body").animate({ scrollTop: top_Actua }, "slow");
            return false;
        });

        $('.btn-export-executor').each(function(){
            let $btn = $(this);
            new BtnExportExecutor({
                '$btn': $btn
            })
        })

        let $partnerSlider = $('.partner-slider')
        if($partnerSlider.length > 0){
            $('.flexslider',$partnerSlider).flexslider({
                'slideshowSpeed': 3000
            });
        }

        this.loadHeader();

        this.initializeShortcuts();

        this.executeAutomneFixes();
    }

    notify(message,level,data,delay){
        if(!data){
            data = null;
        }

        switch(level){
            case 'error':
            case 'err':
            case 'danger':
                data ? console.error(message,data) : console.error(message);
            break;

            case 'warning':
            case 'warn':
                data ? console.warn(message,data) : console.warn(message);
            break;

            case 'success':
            case 'info':
            default:
                //no need to flood the console with success or info
                data ? console.log(message,data) : console.log(message);
            break;
        }

    }
    
    generateLoader(onlyIcon){
        let loader = new Loader({
            'onlyIcon': onlyIcon
        });
        return loader.render();
    }

    onGoogleMapApiLoaded(){
        this.googleMapAvailable = true;

        //console.log("onGoogleMapApiLoaded");

        if(this.events['onGoogleMapApiLoaded']){
            for(var i in this.events['onGoogleMapApiLoaded']){
                let callback = this.events['onGoogleMapApiLoaded'][i];
                callback();
            }
        }
    }

    isGoogleMapAvailable(){
        return this.googleMapAvailable;
    }

    loadHeader(){

        this.menu = new Menu({

        })

        if($('body').hasClass('doc-page')){
            this.menu = new DocMenu({
                'mainContainerSelector': '.doc-page',
            });
        }

    }

    on(eventName,callback){

        if(!this.events[eventName]){
            this.events[eventName] = [];
        }

        this.events[eventName].push(callback);
    }


    executeAutomneFixes(){


        $('textarea').each(function(){
            let $textarea = $(this);

            if($textarea.attr('value')){
                $textarea.val($textarea.attr('value'))
            }
        })
    }

    initializeShortcuts(){

        $('.shortcut-list-item-link').on('click',function(event){
            event.preventDefault();
            event.stopPropagation();


            let $link = $(this);

            let selector = $link.data('target');

            let $target = $(selector);
            window.scrollToElement($target);

            setTimeout(function(){
                let $btnCollapse = $('.btn-collapse',$target);
                if($btnCollapse.length > 0){
                    //$('.btn-collapse[aria-expanded="true"]').trigger('click');
                    $btnCollapse.trigger('click');
                }

            },500);


        })
    }

    isResponsiveEnable(){
        return window.screen.width < 992 ? true : false;
    }
}

module.exports = Application;

